import type { DatePickerProps } from "@components/contracts/DatePicker.types";
import type React from "react";
import {
  DatePicker as RsDatePicker,
  type DatePickerProps as RsDatePickerProps,
} from "rsuite";

import "./DatePicker.component.scss";

const createDateDisabledPredicate = (
  minDate: Date | undefined,
  shouldDisableDate: DatePickerProps["shouldDisableDate"]
): RsDatePickerProps["shouldDisableDate"] => {
  if (!minDate) {
    return shouldDisableDate;
  }

  const earliestDate = new Date(
    minDate.getFullYear(),
    minDate.getMonth(),
    minDate.getDate()
  ).getTime();

  return (date: Date) => {
    const currentDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    ).getTime();

    return currentDate < earliestDate || Boolean(shouldDisableDate?.(date));
  };
};

export const RsuiteDatePicker: React.FC<DatePickerProps> = ({
  id,
  label,
  minDate,
  onChange,
  shouldDisableDate,
  ...props
}) => (
  <div style={{ width: "100%" }}>
    {label && (
      <label htmlFor={id} className="input-label input-label--lg">
        {label}
      </label>
    )}

    <RsDatePicker
      className="custom"
      id={id}
      block
      {...props}
      onChange={(date) => onChange?.(date)}
      shouldDisableDate={createDateDisabledPredicate(
        minDate,
        shouldDisableDate
      )}
    />
  </div>
);
